// Service worker registration with strict iframe/preview guards.
// Per Lovable PWA rules — must NEVER register inside the editor preview.

export function registerPWA() {
  if (typeof window === "undefined") return;

  const isInIframe = (() => {
    try { return window.self !== window.top; } catch { return true; }
  })();

  const host = window.location.hostname;
  const isPreviewHost =
    host.includes("id-preview--") ||
    host.includes("lovableproject.com") ||
    host.includes("lovable.app");

  if (isInIframe || isPreviewHost) {
    // Unregister any existing service workers in preview/iframe contexts
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => r.unregister());
      }).catch(() => {});
    }
    return;
  }

  // Production / installed PWA only
  if ("serviceWorker" in navigator) {
    import("virtual:pwa-register")
      .then(({ registerSW }) => {
        registerSW({ immediate: true });
      })
      .catch(() => { /* PWA module unavailable in dev */ });
  }
}
